<div class="d-flex justify-content-center align-items-center">
  <span class="field-label">{{ 'COMMON.DATA_TABLE_PAGE_SIZE.LABEL' | translate }}</span>
  <hero-dropdown [items]="sizeOptions"
    (selectItem)="onSizeChange($event)"
    [selectedItem]="selectedItem"></hero-dropdown>
</div>